import { DataTableCol } from "../../../components/tables/types";

export const PaymentsDataGridCols: DataTableCol[] = [
    {
        title: 'User Name',
        control: 'name',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'User Email',
        control: 'email',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Phone Number',
        control: 'phone',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];